// Popup window for signing in from a standalone button frame.
//
// The partner's nav sizes the ?embed=auth iframe to the button itself (measured
// on their pages: 300x64). A dialog opened in there is clipped to nothing — its
// backdrop covers the very button that opened it and its Close control sits
// outside the frame's viewport, so the visitor is stuck. When no converter
// frame shares the page there is nowhere in the document to put the dialog, so
// put it in its own window instead.
//
// Same reasoning, and same shape, as the Stripe checkout popup next door: the
// partner's page stays loaded underneath, and the popup reports back to its
// opener (see the msgpdf:auth-complete handling in AppContext).
//
// Deliberately NOT opened with noopener — the popup needs window.opener to hand
// the session back. It is our own origin, so there is no untrusted party here.
//
// `checkoutPlanId` turns this into the whole purchase flow for a signed-out
// visitor who clicked a plan button: the popup signs them in and then navigates
// ITSELF to Stripe rather than closing (see the auth-complete effect in
// AppContext). Opening a second window for Stripe afterwards is not an option —
// by then the click's user activation is spent and blockers refuse it.
//
// Must be called synchronously inside the click handler; anything awaited first
// costs the user activation that popup blockers require. Returns null when the
// browser refuses, so callers can fall back.
export const openAuthPopup = (tab = 'signin', checkoutPlanId = '') => {
  if (typeof window === 'undefined') return null;
  try {
    const w = 480;
    const h = Math.min(700, window.screen?.availHeight || 700);
    const left = Math.max(0, Math.round((window.screen?.availWidth || w) / 2 - w / 2));
    const top = Math.max(0, Math.round(((window.screen?.availHeight || h) - h) / 3));
    const url = `${window.location.origin}/?authPopup=1&tab=${encodeURIComponent(tab)}`
      + (checkoutPlanId ? `&checkout=${encodeURIComponent(checkoutPlanId)}` : '');
    // A fixed window name means a second click focuses the window already open
    // rather than stacking another one.
    return window.open(url, 'msgpdf-auth', `popup=yes,width=${w},height=${h},left=${left},top=${top}`) || null;
  } catch (_) {
    return null;
  }
};
